const PortfolioSizeHeader = () => {
  return (
    <div>
      <p className="text-gray-600 mb-6">
        Let's start by understanding the value of your investment portfolio.
      </p>
    </div>
  );
};

export default PortfolioSizeHeader;